import React from 'react';

import styled from 'styled-components';

import { Icon } from '../Icon';

const IconBulletContainer = styled.div`
  display: flex;
  gap: 13px;
  align-items: flex-start;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-weight: bold;
  color: var(--stile-grey-8);
  margin: 0;
  font-size: var(--font-size-h8);
  line-height: var(--line-height-h8);
`;

const Text = styled.div`
  color: var(--stile-grey-8);
  font-size: 14px;
  line-height: 1.4;
`;

interface IconBulletProps {
  iconSrc: string | React.ReactNode;
  title: string;
  text: string | React.ReactNode;
  iconSize?: string;
}

export const IconBullet: React.FC<IconBulletProps> = ({
  iconSrc,
  title,
  text,
  iconSize = '38px',
}) => {
  return (
    <IconBulletContainer>
      {typeof iconSrc === 'string' ? (
        <Icon src={iconSrc} iconSize={iconSize} />
      ) : (
        <div style={{ width: iconSize, height: iconSize, flexShrink: 0 }}>{iconSrc}</div>
      )}
      <TextContent>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </TextContent>
    </IconBulletContainer>
  );
};

export default IconBullet;
